import { useState } from 'react';

export function buildImageList(imagenes, filesPendientes, deletePendientes) {
  return [
    ...imagenes.filter((img) => !deletePendientes.includes(img.prioridad)),
    ...filesPendientes.map((f, i) => ({
      _esPendiente: true,
      _fileIdx: i,
      tipo: f.tipo,
      previewUrl: f.previewUrl,
      prioridad: -(i + 1),
    })),
  ];
}

export function buildImageDisplay(imagenes, filesPendientes, deletePendientes) {
  return [
    ...imagenes.filter((img) => !deletePendientes.includes(img.prioridad)),
    ...filesPendientes.map((f, i) => ({
      url: f.previewUrl,
      prioridad: -(i + 1),
      tipo: f.tipo,
      _esPendiente: true,
    })),
  ];
}

export default function useImageReorder({
  imagenes,
  filesPendientes,
  deletePendientes,
  setImagenes,
  setFilesPendientes,
}) {
  const [dragIdx, setDragIdx] = useState(null);

  const handleDragStart = (e, idx) => {
    setDragIdx(idx);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIdx) => {
    e.preventDefault();
    if (dragIdx === null || dragIdx === dropIdx) return;
    const combined = buildImageList(imagenes, filesPendientes, deletePendientes);
    const [item] = combined.splice(dragIdx, 1);
    combined.splice(dropIdx, 0, item);
    setImagenes(combined.filter((i) => !i._esPendiente));
    const newPendingOrder = combined.filter((i) => i._esPendiente);
    setFilesPendientes(newPendingOrder.map((i) => filesPendientes[i._fileIdx]));
    setDragIdx(dropIdx);
  };

  const handleDragEnd = () => setDragIdx(null);

  return { dragIdx, handleDragStart, handleDragOver, handleDrop, handleDragEnd };
}
